
defsPackEditor.title.placeholder=Introduzca el título del juego de cartas (tema o algo)
defsPackEditor.description.placeholder=Introduzca breve descripción del juego de cartas
defsPackEditor.title.create=Crear nuevas tarjetas didácticas
defsPackEditor.title.save=Editar tarjetas didácticas
defsPackEditor.addPackImage=Añadir imagen
visibility.label=Visible para
visibility.0=Sólo yo
visibility.1=Todos (después de la comprobación)
visibility.2=Verificación
visibilityBadge.0=Privado
visibilityBadge.1=Público
visibilityBadge.2=Verificación
## не удаляйте этот блок, на него есть ссылки в {plurals}
pl.card.one=tarjeta
pl.card.few=tarjetas
pl.card.other=tarjetas
pl.day.one=día
pl.day.few=días
pl.day.other=días
pl.passedReview.one=pasó la revisión
pl.passedReview.few=revisiones aprobadas
pl.passedReview.other=revisiones aprobadas
pl.failedReview.one=revisión fallida
pl.failedReview.few=revisiones fallidas
pl.failedReview.other=revisiones fallidas
pl.freshCard.one=tarjeta nueva
pl.freshCard.few=tarjetas nuevas
pl.freshCard.other=tarjetas nuevas
pl.hours.one=hora
pl.hours.few=horas
pl.hours.other=horas
pl.hours={0} {0,plural,one{hora}few{horas}other{horas}}
pl.days.one=día
pl.days.few=días
pl.days.other=días
pl.days={0} {0,plural,one{día}few{días}other{días}}
pl.minutes.one=minuto
pl.minutes.few=minutos
pl.minutes.other=minutos
pl.minutes={0} {0,plural,one{minuto}few{minutos}other{minutos}}
## validation
rubd.flashcards.services.validation.SideTextWhenCardIsNotEmpty.message=La tarjeta no está vacía, necesitas algún texto para este lado
##
button.save=Salvar
button.saveContinue=Guardar y continuar
button.create=Crear
button.cancel=Cancelar
button.clone=Clon
button.print=Imprimir
button.checkTest=Comprobar resultados
button.yes=Sí
button.close=Cerca
button.ok=De acuerdo
button.help=Ayuda
##
title.label=Título
title.description=Descripción
title.optional=(opcional)
## duration messages
fl.agoString=Hace {0}
fl.agoRecently=Recientemente
fl.timeSpent={0} gastado
fl.timeSpentLessThanMinute=Pasé un poco
##
pack.cardCount={0} tarjetas
pack.cardCount.one={0} tarjeta
pack.cardCount.many={0} tarjetas
pack.cardCount.few={0} tarjetas
##
page.defaultTitle=FlashCards en línea
## user private dashboard
fl.mainDashboard.packAgo.title=Tiempo transcurrido desde la última visita
fl.mainDashboard.packSpent.title=Tiempo dedicado al aprendizaje
fl.mainDashboard.hideMemoPack=Este conjunto se eliminará del Panel de Aprendizaje a Largo Plazo. Para volver a agregarlo, deberá hacer clic en "Comenzar a aprender" en la página del conjunto.
##
packEditor.form.termLanguage=Lenguaje del término
packEditor.form.termLanguage.placeholder=Elija el idioma
packEditor.form.definitionLanguage=Lenguaje de definición
packEditor.form.definitionLanguage.placeholder=Elija el idioma
packEditor.form.loading=Cargando lista de tarjetas...
packEditor.form.cardMinimum=Por favor, rellene al menos dos flashcards
packEditor.importer.open=Importar desde txt, Word, Excel, Google Docs, etc.
packEditor.importer.close=Cerrar
packEditor.importer.import=Importar
packEditor.importer.textLabel=Copie y pegue texto aquí (desde Word, Excel, Google Docs, etc.)
packEditor.importer.textPlaceholder=Palabra 1   Definición 1\nPalabra 2   Definición 2\nPalabra 3   Definición 3
packEditor.importer.result=Se importaron {0} entradas
packEditor.importer.preview.title=Vista previa de las tarjetas
packEditor.importer.preview.empty=No se han reconocido las tarjetas. Verifique la configuración de importación en el panel derecho.
packEditor.anki.button=Importar Anki
packEditor.anki.dialog.message=Sube tu archivo .APKG para importar tu mazo de tarjetas didácticas ANKI.
packEditor.anki.dialog.notice1=Algunos mazos no se pueden importar o pueden tener errores. Depende de la estructura del mazo. Lo sentimos.
packEditor.anki.dialog.notice2=Puedes importar tus propios decks o decks que tengas derecho a copiar y modificar.
packEditor.anki.dialog.title=Importar tarjetas didácticas de Anki
packEditor.anki.dialog.button=Navegar
packEditor.anki.progress.sending=Enviando archivo...
packEditor.anki.progress.parsing=Analizando archivo...
packEditor.anki.progress.forming=Insertando resultado en formulario...
packEditor.anki.progress.error=Error en la importación.
packEditor.anki.progress.success=Operación completada. Se han añadido nuevas tarjetas a la lista a continuación.
packEditor.addRow=Agregar tarjeta
packEditor.card.term.placeholder=Término
packEditor.card.term.needText=Necesito texto aquí
packEditor.card.def.placeholder=Definición
packEditor.card.def.needText=Necesito texto aquí
packEditor.importer.form.mode=Modo de importación
packEditor.importer.form.mode.everyLine=Término y definición en cada línea, separados por delimitador.
packEditor.importer.form.mode.lineByLine=El término y la definición son secuenciales, un elemento por línea.
packEditor.importer.form.everyLine1=Delimitador de entrada (línea)
packEditor.importer.form.everyLine2=Término / definición delimitador
packEditor.importer.form.everyLine3=Opciones adicionales
packEditor.importer.form.ldLine=Envoltura de línea
packEditor.importer.form.ldDoubleLine=Doble línea de envoltura
packEditor.importer.form.ldCustom=Símbolo personalizado
packEditor.importer.form.ldJoinLowercase=Únete a la línea que comienza con un símbolo en minúscula
packEditor.importer.form.tdDash=Dash (-)
packEditor.importer.form.tdTab=Lengüeta
packEditor.importer.form.tdCustom=Símbolo personalizado
packEditor.importer.form.lineByLine1=Opciones adicionales
packEditor.importer.form.llDoubleLine=Doble línea de envoltura entre cada grupo
packEditor.importer.form.llJoinLowercase=Únete a la línea que comienza con un símbolo en minúscula
packEditor.splitNewCards.notice=Parece que tienes muchas cartas. Tal vez sea razonable dividir las tarjetas en varios juegos
packEditor.splitNewCards.checkbox.1=Sí, dividir las cartas en
packEditor.splitNewCards.checkbox.2=piezas en cada set
packEditor.splitNewCards.shuffle=Y baraja las cartas antes de dividirlas.
packEditor.splitNewCards.suffix=Parte {0}.
packEditor.putToCollection=Añadir paquete a
packEditor.putToCollection.none=<none>
packEditor.putToCollection.createNew=colección o {0}crear nuevo{1}.
packEditor.images.search=Buscar imágenes
packEditor.images.search.or=o
packEditor.images.upload=Subir
packEditor.images.remove=Eliminar imagen
packEditor.images.emptySearch=No se encontraron imágenes. Prueba con otra consulta.
packEditor.audio.record=Registro
packEditor.audio.remove=Eliminar
packEditor.audio.upload=Subir
##
collectionForm.modal.title=Crear nueva colección
collectionForm.name=Nombre
collectionForm.name.placeholder=Escriba el nombre de la colección
collectionForm.description=Descripción
collectionForm.description.placeholder=Tipo de descripción de la colección
##
myPage.title.author=Mis propios sets
myPage.title.lastPacks=Mis ultimos sets
myPage.title.favourite=Mis sets favoritos
myPage.empty.last=No has visitado ningún set.
myPage.empty.author=No has creado ningún conjunto.
myPage.empty.favourite=Tu lista de favoritos está vacía
##
packPage.header.from=por
packPage.buttonGroup.play=Jugar
packPage.button.play=Tarjetas
packPage.button.test=Prueba
packPage.button.learn=Aprender
packPage.button.write=Escribir
packPage.button.spell=Deletrear
packPage.button.match=Fósforo
packPage.button.live=Vivir
packPage.solw.short=Aprendizaje rápido
packPage.solw.short.subtitle=Repita este conjunto de tarjetas didácticas
packPage.solw.short.new=Nuevo:
packPage.solw.short.familiar=Familiar:
packPage.solw.short.mastered=Dominado:
packPage.solw.long=Aprendizaje a largo plazo
packPage.solw.long.subtitle=Repetición espaciada
packPage.solw.long.today=Tarea de hoy
packPage.solw.long.new=Nuevo:
packPage.solw.long.review=Para revisar:
packPage.button.memo=Memorándum
ppp0.title=¿Quieres aprender este conjunto rápidamente?
packPage.dialogs.forbidden.alert=Disponible solo para usuarios autorizados
packPage.dialogs.forbidden.addToCollection.text=Puedes añadir este conjunto a una de tus colecciones.
packPage.dialogs.forbidden.addToCollection.alert=Disponible solo para usuarios autorizados
packPage.dialogs.forbidden.createNew.title=¡Bienvenido!
packPage.dialogs.forbidden.createNew.text=Sólo los usuarios autorizados pueden crear nuevas tarjetas.
packPage.dialogs.forbidden.clone.text=Si usa estas tarjetas para estudiar, pero desea complementarlas, solo clónelas y cree un nuevo conjunto que necesite.
packPage.dialogs.forbidden.clone.alert=Disponible solo para usuarios autorizados
packPage.dialogs.addToCollection.title=Añadir este conjunto a la colección
packPage.dialogs.addToCollection.notice=Puedes agregar este conjunto de flashcards a tus colecciones de estudio
packPage.dialogs.addToCollection.createNew= + Añadir nueva colección
packPage.dialogs.addToCollection.forbidden=Solo usuarios autorizados pueden agregar tarjetas a sus cursos.
packPage.dialogs.addToFavourites.title=Añadir este conjunto a guardado
packPage.dialogs.addToFavourites.forbidden=Puede agregar guardar este conjunto para volver más tarde
packPage.dialogs.login=Iniciar sesión / registrarse
packPage.dialogs.share.title=Comparte este set
packPage.dialogs.clone.title=Clonar este conjunto
packPage.dialogs.clone.notice=Si usa estas tarjetas para estudiar, pero desea complementarlas, solo clónelas y cree un nuevo conjunto que necesite.
packPage.command.edit=Editar
packPage.command.customize=Personalizar
packPage.command.addTo=Añadir ...
packPage.command.addTo.collection=colección
packPage.command.addTo.saved=salvado
packPage.command.share=Compartir
packPage.list.sorting.original=Original
packPage.list.sorting.alphabetical=Alfabético
packPage.list.filter.all=Mostrar todo
packPage.list.filter.difficult=Difícil
packPage.list.filter.banned=Ignorado
packPage.list.filter.mastered=Dominado
packPage.list.filter.familiar=Familiar
packPage.list.filter.starred=Sembrado de estrellas
packPage.list.emptyMessage=Ninguna tarjeta se ajusta a este filtro
packPage.list.loadMore=Ver más tarjetas
packPage.review=Revisar
packPage.startMemo=Añadir al escritorio de aprendizaje a largo plazo
packPage.startLearning=Empieza a aprender
packPage.speedReview=Revisión de velocidad
packEmbed.clickToFlip=Haga clic para voltear
packPage.tooltips.memoShort=El modo de aprendizaje rápido es útil cuando necesitas repetir algunas palabras o preguntas antes del examen. Es adecuado para conjuntos pequeños de palabras.
packPage.tooltips.memoLong=El modo de aprendizaje de repetición espaciada se basa en el método de repetición por intervalos. Resulta útil para la preparación sistemática de exámenes y la formación a largo plazo.
packPage.tooltips.preview=Vea todos los conjuntos de cartas sin tener que controlarse.
packPage.tooltips.test=Crea una prueba para comprobar tus conocimientos sobre un conjunto de tarjetas.
packPage.tooltips.spell=Corrector ortográfico. Prueba de comprensión auditiva y escritura.
##
packPlay.back=Espalda
packPlay.options=Opciones
packPlay.progress=Progreso
packPlay.progressTemplate={0} de {1}
packPlay.wrongDisplay.title=Respuesta incorrecta
packPlay.wrongDisplay.label=Respuesta correcta
packPlay.wrongDisplay.continueText=Pulse cualquier tecla para continuar
packPlay.wrongDisplay.userLabel=Tu escribiste
packPlay.wrongDisplay.typeText=Escriba la respuesta correcta a continuación
##
packLearn.remaining=Restante
packLearn.familiar=Familiar
packLearn.mastered=Dominado
packLearn.write.placeholder=escribe tu respuesta aquí
packLearn.write.placeholderCopy=copia la respuesta correcta aquí
packLearn.write.submit=Responder
packLearn.write.skip=Saltar
packLearn.write.stillCorrect=Yo tenía razón
packLearn.write.giveup=Rendirse
packLearn.dialogs.options.title=Opciones
packLearn.dialogs.options.questionTitle=Responder con
packLearn.dialogs.options.questionTerm=Término
packLearn.dialogs.options.questionDefinition=Definición
packLearn.dialogs.options.questionError=Al menos una casilla debe estar marcada.
packLearn.dialogs.options.modeTitle=Tipos de preguntas
packLearn.dialogs.options.modeSelect=Opción multiple
packLearn.dialogs.options.modeWrite=Escrito
packLearn.dialogs.options.modeError=Al menos una casilla debe estar marcada.
packLearn.dialogs.options.modeRandom=Orden aleatorio
packLearn.dialogs.options.resetTitle=Restablecer progreso
packLearn.dialogs.options.resetButton=Reiniciar
packLearn.dialogs.options.modeCards=Tarjetas didácticas
packLearn.dialogs.config.title=Opciones de nota
packLearn.dialogs.firstTime.title=Configuración por primera vez
packLearn.dialogs.firstTime.notice=Puede cambiar esta configuración en cualquier momento en el menú "Opciones".
packLearn.dialogs.options.writeAnyAnswer=Escribe cualquier respuesta
packLearn.dialogs.options.writeAnyAnswer.notice=Puede escribir sólo una de las respuestas disponibles (que están separadas por coma).
packLearn.dialogs.options.playAudio=Reproducir audio
packLearn.dialogs.options.newLimit=Nuevo límite de tarjetas
packLearn.dialogs.options.newLimitError=Debe ser un número positivo, menor o igual a 50.
packLearn.dialogs.options.order=Orden de nuevo
packLearn.dialogs.options.order.original=Original
packLearn.dialogs.options.order.random=Aleatorio
packLearn.dialogs.options.advancedMode=Modo avanzado
packLearn.dialogs.options.advancedMode.notice=Por defecto, el "aprendizaje a largo plazo" utiliza un algoritmo de aprendizaje modificado de repetición espaciada, donde basta con seleccionar "Sabe" o "No sabe". Al cambiar al "Modo avanzado", se puede usar un algoritmo clásico con cinco opciones disponibles, similar a Supermemo o Anki.
##
searchPage.title=Buscar "{0}"
searchPage.head=Resultados para la consulta "{0}"
searchPage.display.packs=Mostrar conjuntos
searchPage.display.courses=Mostrar cursos
searchPage.noResults.packs=Lo sentimos, no se ha encontrado ningún conjunto
searchPage.noResults.courses=Lo sentimos, no se han encontrado cursos
##
learnPage.progress.total=Pasado
learnPage.progress.correct=Correcto
learnPage.progress.wrong=Incorrecto
learnPage.answer.go=Responder
learnPage.answer.placeholder=Escribe tu respuesta
learnPage.answer.unknown=No lo sé
learnPage.wrong.stillCorrect=Mi respuesta es correcta!
learnPage.next=Siguiente
learnPage.result.actual=Tu respuesta
learnPage.result.correct=Respuesta correcta
learnPage.header.correct=Respuesta correcta
learnPage.header.wrong=Respuesta incorrecta
learnPage.emptyQueue=¡Felicidades! Has aprobado todas las tarjetas.
learnPage.restartQueue=Reanudar
learnPage.reviewComplete.title=¡Felicidades!
learnPage.reviewComplete.text=Has pasado todas las cartas.
##
testSelectPage.opt.limit=Límite de preguntas
testSelectPage.opt.first=Show
testSelectPage.start=Iniciar prueba
testSelectPage.opt.limit.prefix=Utilizar
testSelectPage.opt.limit.suffix=de {0}
testSelectPage.opt.first.face=Término
testSelectPage.opt.first.back=Definición
testSelectPage.mode1=Partido
testSelectPage.mode2=Si/no
testSelectPage.mode3=4 opciones
testSelectPage.mode4=Escribir
##
testResult.message=Tu puntuación:
testResult.correctTitle=Respuesta esperada
testResult.noAnswer=No seleccionas nada
testResult.noAnswerWrite=No escribes nada
testCheck.answer=Responder:
testCheck.answer.yes=Correcto
testCheck.answer.no=Incorrecto
testCheck.answer.correct=¡Correcto!
testCheck.answer.wrong=¡Incorrecto!
testWrite.input.placeholder=Escriba su respuesta aquí
##
uknownPack.text=Tal vez teníamos este set antes ... Desafortunadamente, ya no está disponible :(
packOnVerification.text=Este paquete estará disponible para el público tras la verificación. Espere, por favor.
##
packTest.form.questionLimit=Límite de preguntas
packTest.form.questionLimit.of=de
packTest.form.questionLimit.invalid=El recuento de preguntas no es válido.
packTest.form.questionWith=Pregunta con
packTest.form.questionWith.notSelected=Se requiere al menos una opción.
packTest.form.requireOne=Requerir solo una respuesta
packTest.form.requireOne.explain=Se requiere al menos una respuesta correcta. Las respuestas deben estar separadas por una barra (/), una coma (,) o un punto y coma (;)
packTest.form.types=Tipos de preguntas
packTest.form.types.notSelected=Se requiere al menos una opción.
packTest.form.type.choice=Opción multiple
packTest.form.type.yn=Verdadero/Falso
packTest.form.type.written=Escrito
packTest.form.type.matching=Pareo
packTest.start=Iniciar prueba
packTest.qsMatching=Preguntas para emparejar
packTest.qsMatching.expected=La respuesta correcta es:
packTest.qsWritten=Preguntas para escribir
packTest.qsWritten.inputPlaceholder=escriba su respuesta aquí
packTest.qsWritten.expected=La respuesta correcta es:
packTest.qsChoice=Preguntas para elegir
packTest.qsChoice.expected=La respuesta correcta es:
packTest.qsYN=Preguntas para verdadero / falso
packTest.qsYN.true=Cierto
packTest.qsYN.false=Falso
packTest.qsYN.expected=La respuesta correcta es:
packTest.checkAnswers=Revisar respuestas
packTest.score.prefix=Resultado de la prueba:
packTest.score.90=¡Excelente!
packTest.score.75=¡Bueno!
packTest.score.50=Promedio
packTest.score.25=Pobre
packTest.score.0=Débiles
##
columns.cardsInPack=Canti.
##
fexplorer.page.title={0} flashcards explorer
fexplorer.page.categoryTitle={0} tarjetas
fexplorer.title=Catálogo de tarjetas
fexplorer.popularsCategories=Categorías Populares
fexplorer.language=Mi idioma
fexplorer.allCategories=Todas las categorias
fexplorer.collections.section=Colecciones
fexplorer.flashcards.section=Fichas
fexplorer.flashcards.terms=término
fexplorer.empty.message=Por favor seleccione una categoría <br> o <br>
fexplorer.empty.search=Buscar algo
##
packPlay.progressBar.title=Progreso
packPlay.head.play=Tarjetas didácticas
packPlay.head.learn=Aprender
packPlay.head.review=Revisar
packPlay.head.test=Prueba
packPlay.head.write=Escribir
packPlay.head.memo=Memorándum
packPlay.head.spell=Deletrear
packPlay.head.match=Fósforo
##
packMemo.showAnswer=Mostrar respuesta
packMemo.sessionComplete=¡No más tarjetas por hoy!
packMemo.sessionNextTime=Regresa en {0}.
packMemo.grades.button.H=Difícilmente
packMemo.grades.button.E=Fácil
packMemo.grades.button.M=Medio
packMemo.grades.button.1=Malo
packMemo.grades.button.2=Débil
packMemo.grades.button.3=Medio
packMemo.grades.button.4=Bien
packMemo.grades.button.5=Fuerte
packMemo.grades.button.Y=Ok, lo recuerdo
packMemo.grades.button.R=Sé
packMemo.grades.button.F=No sé
packMemo.short.days=d
packMemo.short.months=me
packMemo.short.hours=h
packMemo.welcome.title=Mesa de aprendizaje a largo plazo
packMemo.welcome.text=Es un programador de repetición espaciada. Una vez que comiences el proceso de aprendizaje, aprenderás 20 cartas cada día. La frecuencia con la que se muestran las cartas depende de tus respuestas. Este modo se basa en el famoso algoritmo de repetición espaciada SM-2. <br><a href="https://en.wikipedia.org/wiki/SuperMemo">Leer más.</a>
packMemo.welcome.start=Vamos a empezar
packMemo.welcome.login=Lamentablemente, este modo solo está disponible para usuarios autorizados.<br>Por favor, <a href="/login">inicie sesión</a> o <a href="/registration">regístrese</a>. <br>Es fácil y totalmente gratis.




packMemo.help.title=Pista
packMemo.help.line1=Barra espaciadora para mostrar la respuesta
packMemo.help.line2=1,2,3,4,5 para hacer tu elección
packMemo.help.hide=Esconder
packMemo.end.freshAvailable=¿Quieres ver más cartas nuevas hoy?
packMemo.end.freshAccept=Sí, muéstrame más.
##
fl.matchGame.welcome.text=Arrastre elementos uno sobre otro para hacerlos desaparecer
fl.matchGame.startGame=Iniciar juego
fl.matchGame.timer=Tiempo
fl.matchGame.preset.number=Contar
fl.matchGame.result.title=¡Felicidades!
fl.matchGame.result.text=Tu puntuación es {0} segundos
fl.matchGame.result.again=Jugar de nuevo
##
fl.memoHeatMap.title=Tu historial de aprendizaje
fl.memoHeatMap.legend.daverage=Promedio diario:
fl.memoHeatMap.legend.daverage.value={0} {0,plural,one{tarjeta}few{tarjetas}other{tarjetas}}
fl.memoHeatMap.legend.dlearned=Días aprendidos:

fl.memoHeatMap.legend.beststreak=Mejor racha:
fl.memoHeatMap.legend.beststreak.value={0} {0,plural,one{día}few{días}other{días}}
fl.memoHeatMap.legend.currentstreak=Racha actual:
fl.memoHeatMap.legend.currentstreak.value={0} {0,plural,one{día}few{días}other{días}}
fl.memoHeatMap.tooltip.passed={0} {0,plural,one{pasó la revisión}few{revisiones aprobadas}other{revisiones aprobadas}}
fl.memoHeatMap.tooltip.failed={0} {0,plural,one{revisión fallida}few{revisiones fallidas}other{revisiones fallidas}}
fl.memoHeatMap.tooltip.fresh={0} {0,plural,one{tarjeta nueva}few{tarjetas nuevas}other{tarjetas nuevas}}
fl.memoHeatMap.tooltip.date=el {0}
##
cardButtons.ban.title=Prohibir esta tarjeta
cardButtons.edit.title=Corrija esta tarjeta
cardButtons.star.title=Activar o desactivar tarjeta favorita
cardButtons.ban.prompt=¿Ignorar esta tarjeta?
##
validation.cardText.tooLong=La longitud máxima de este texto es de 1000 caracteres.
##
extLocale.la=latín
extLocale.rw=Kinyarwanda
extLocale.af=africaans
extLocale.am=Amárico
extLocale.az=azerbaiyano
extLocale.bn=Bengala
extLocale.bs=bosnio
extLocale.ceb=Cebuano
extLocale.co=corso
extLocale.cy=galés
extLocale.eo=esperanto
extLocale.eu=vasco
extLocale.fa=persa
extLocale.fy=frisio
extLocale.gd=escocés (gaélico)
extLocale.gl=gallego
extLocale.gu=Gujarati
extLocale.ha=Casa
extLocale.haw=hawaiano
extLocale.hmn=Hmong
extLocale.ht=criollo (Haití)
extLocale.hy=armenio
extLocale.id=indonesio
extLocale.ig=Igbo
extLocale.jw=javanés
extLocale.ka=georgiano
extLocale.kk=kazajo
extLocale.km=Jemer
extLocale.kn=Canarés
extLocale.ku=Kurmanji
extLocale.ky=Kirguistán
extLocale.lb=Luxemburgo
extLocale.lo=Laosiano
extLocale.mg=madagascarí
extLocale.mi=maorí
extLocale.ml=Malabar
extLocale.mn=mongol
extLocale.mr=Maratí
extLocale.my=birmano
extLocale.ne=Nepalí
extLocale.ny=Ceva
extLocale.or=Oria
extLocale.pa=punjabi
extLocale.ps=Pastún
extLocale.sd=Sindhi
extLocale.si=cingaleses
extLocale.sm=Samoano
extLocale.sn=Shona
extLocale.so=somalí
extLocale.st=Sesotho
extLocale.su=sudanés
extLocale.sw=swahili
extLocale.ta=Tamil
extLocale.te=Telugu
extLocale.tg=Tayiko
extLocale.tk=turcomano
extLocale.tl=filipino
extLocale.tt=Tártaro
extLocale.ug=uigur
extLocale.ur=Urdu
extLocale.uz=uzbeko
extLocale.xh=Xhosa
extLocale.yi=yídish
extLocale.yo=Yoruba
extLocale.zu=zulú


# landing
fl.landing.title=Aprendiendo con {0}
fl.landing.title.small=Descubre lo que {0} puede aportar a tu proceso de aprendizaje
fl.landing.why1.title=Es fácil y divertido.
fl.landing.why1.text=Miles de escolares y estudiantes hacen sus tareas {0} a diario, mejorando sus calificaciones. En el sofá, en el metro, en la cola... siempre hay minutos para estudiar.
fl.landing.why2.title=Seis modos de aprendizaje
fl.landing.why2.text=Elige las herramientas que mejor se adapten a la información que necesitas aprender.
fl.landing.why3.title=Repetición espaciada
fl.landing.why3.text=Basado en el estudio de la psicología, el método de repetición espaciada permite recordar grandes cantidades de información sin un esfuerzo extraordinario. Basta con practicarlo de 10 a 15 minutos al día.
fl.landing.why4.title=En cualquier dispositivo
fl.landing.why4.text=Trabaja en el dispositivo que tengas a mano. No importa si es una computadora, una tableta o un teléfono: nuestras herramientas están optimizadas para ellos.
fl.landing.create.title=Crea tus propios juegos de cartas
fl.landing.create1.title=Creando memorización
fl.landing.create1.text=Para preparar un conjunto, debes estructurar y simplificar la información. Esta es una de las mejores maneras de dominar el material. En el futuro, solo necesitarás refrescar la memoria.
fl.landing.create2.title=Importación conveniente
fl.landing.create2.text=Utilice la herramienta flexible de importación de archivos de texto para cargar conjuntos de otras fuentes. También puede importar un archivo ANKI.
fl.landing.create3.title=Modificar
fl.landing.create3.text=Seleccione un conjunto adecuado de nuestra base de datos, modifíquelo y complételo de acuerdo con su plan de estudios.
fl.landing.create.button=Crear un conjunto
fl.landing.gallery=Ejemplos
fl.landing.gallery.others=Ver otros ejemplos
fl.landing.stars1=3 millones de estudiantes cada mes
fl.landing.stars2=Más de 100 000 000 sesiones de formación
fl.landing.stars3=Más de 1.000.000 kits educativos
fl.landing.reg1=Únase ahora y utilice tarjetas educativas de entrenamiento por intervalos, colecciones educativas y documentos educativos útiles.
fl.landing.reg2=¿No tienes cuenta de Google ni Facebook? ¡No hay problema! Regístrate con tu correo electrónico.
## fast add card










## uninstall page
fl_uninstall_title=Gracias por utilizar la extensión Studylib.
fl_uninstall_subtitle=¡Lamentamos que te vayas! Si tienes un momento, cuéntanos cómo podemos mejorar la extensión:
fl_uninstall_notice=Tus comentarios nos ayudan a mejorar el producto para todos, gracias 😊
fl_uninstall_button=Enviar
fl_uninstall_success=¡Nos vemos pronto!

## APPEND ITEMS ABOVE THIS LINE